import React from "react";

const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 2.5C12.2958 2.5 14.5458 2.69334 16.7358 3.065C17.18 3.14 17.5 3.52834 17.5 3.97834V4.84834C17.5 5.09457 17.4515 5.33838 17.3573 5.56587C17.2631 5.79336 17.1249 6.00006 16.9508 6.17417L12.4242 10.7008C12.2501 10.8749 12.1119 11.0816 12.0177 11.3091C11.9235 11.5366 11.875 11.7804 11.875 12.0267V14.4658C11.8751 14.8141 11.7781 15.1556 11.595 15.4519C11.4119 15.7482 11.1499 15.9876 10.8383 16.1433L8.125 17.5V12.0267C8.125 11.7804 8.07651 11.5366 7.98228 11.3091C7.88805 11.0816 7.74994 10.8749 7.57583 10.7008L3.04917 6.17417C2.87506 6.00006 2.73695 5.79336 2.64272 5.56587C2.54849 5.33838 2.5 5.09457 2.5 4.84834V3.97834C2.5 3.52834 2.82 3.14 3.26417 3.065C5.48964 2.68821 7.74286 2.49921 10 2.5Z"
      stroke="#232D3B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FilterIcon;
